/*! Copyright (c) Safe As Milk. All rights reserved. */
function tabClick(e) {
    if (e.keyCode === 9) {
        document.body.classList.add("js-using-tab");
        window.removeEventListener("keydown", tabClick);
    }
}

window.addEventListener("keydown", tabClick);

window.theme ??= {};

window.theme.wrapRteTables = (rootElement = document) => {
    const wrapTable = (el, wrapper) => {
        el.parentNode.insertBefore(wrapper, el);
        wrapper.appendChild(el);
    };
    rootElement.querySelectorAll(".rte table").forEach((table => {
        if (table.closest(".js-theme-utility-rte-table-wrap")) return;
        const tableWrapper = document.createElement("div");
        tableWrapper.classList.add("js-theme-utility-rte-table-wrap");
        tableWrapper.setAttribute("style", "overflow:auto;-webkit-overflow-scrolling:touch");
        wrapTable(table, tableWrapper);
    }));
};

/* custom js by gj */
window.theme.productCollSwatch = function () {

  function createSrcsetString(srcSetWidths, url, originalWidth, originalHeight) {
    if (!srcSetWidths || !url || !originalWidth || !originalHeight) return "";

    const aspectRatio =
      parseInt(originalHeight, 10) / parseInt(originalWidth, 10);

    return srcSetWidths.reduce(function (srcSetString, srcSetWidth) {
      const sizeHeight = Math.floor(srcSetWidth * aspectRatio);
      return (
        srcSetString +
        url.replace("{width}", srcSetWidth) +
        " " +
        srcSetWidth +
        "w " +
        sizeHeight +
        "h,"
      );
    }, "");
  }

  document.querySelectorAll(".product-card__swatch__item").forEach(function (swatch) {
    swatch.addEventListener("click", function (e) {
      e.preventDefault();

      const currentProduct = this.closest(".js-product");
      if (!currentProduct) return;

      const currentProductImage = currentProduct.querySelector(".product-card__img");

      const variantProductImage = this.dataset.variantImage;
      const variantProductImageWidth = this.dataset.variantImageWidth;
      const variantProductImageHeight = this.dataset.variantImageHeight;
      const variantUrl = this.dataset.variantUrl;

      const newSrc = variantProductImage.replace("{width}", "300");
      const newSrcset = createSrcsetString(
        [180, 360, 540, 720, 900, 1080, 1296, 1512],
        variantProductImage,
        variantProductImageWidth,
        variantProductImageHeight
      );

      // replace product image
      currentProductImage.setAttribute("src", newSrc);
      currentProductImage.setAttribute("width", "300");
      currentProductImage.setAttribute(
        "height",
        Math.floor(
          300 *
            (parseInt(variantProductImageHeight, 10) /
              parseInt(variantProductImageWidth, 10))
        )
      );
      currentProductImage.setAttribute("srcset", newSrcset);

      // replace product variant link
      const productLink = currentProduct.querySelector(".js-product-link");
      if (productLink) {
        productLink.setAttribute("href", variantUrl);
      }

      // set swatch to active
      currentProduct
        .querySelectorAll(".js-product-swatch-item")
        .forEach(item => item.classList.remove("js-active"));

      this.classList.add("js-active");
    });
  });
};
/* end custom js by gj */

// custom js by gj 
window.theme.accordion = function () {
  const items = document.querySelectorAll(".js-accordion-info");
  const triggers = document.querySelectorAll(".js-accordion-trigger");

  const activeClass = "js-active";
  const defaultOpenClass = "js-accordion-trigger-default-open";

  // --- helpers ---
  function slideDown(el, duration = 400) {
    el.style.display = "block";
    const height = el.scrollHeight + "px";

    el.style.height = "0";
    el.style.overflow = "hidden";
    el.style.transition = `height ${duration}ms`;

    requestAnimationFrame(() => {
      el.style.height = height;
    });

    setTimeout(() => {
      el.style.height = "";
      el.style.overflow = "";
      el.style.transition = "";
    }, duration);
  }

  function slideUp(el, duration = 400) {
    el.style.height = el.scrollHeight + "px";
    el.style.overflow = "hidden";
    el.style.transition = `height ${duration}ms`;

    requestAnimationFrame(() => {
      el.style.height = "0";
    });

    setTimeout(() => {
      el.style.display = "none";
      el.style.height = "";
      el.style.overflow = "";
      el.style.transition = "";
    }, duration);
  }

  // hide all items initially
  items.forEach(item => {
    item.style.display = "none";
  });

  // open default items
  triggers.forEach(trigger => {
    if (trigger.classList.contains(defaultOpenClass)) {
      const target = document.querySelector(trigger.getAttribute("href"));
      if (!target) return;

      target.classList.add(activeClass);
      slideDown(target);
      trigger.classList.add(activeClass);
      trigger.setAttribute("aria-expanded", "true");
    }
  });

  // click handling
  triggers.forEach(trigger => {
    trigger.addEventListener("click", function (e) {
      e.preventDefault();

      const target = document.querySelector(this.getAttribute("href"));
      if (!target) return;

      // recalc product box after animation
      setTimeout(() => {
        const productBox = document.querySelector(".js-product-single-box");
        if (productBox) {
          productBox.dispatchEvent(new Event("resize"));
        }
      }, 400);

      // scroll + open behavior
      if (this.classList.contains("js-accordion-scroll")) {
        const outsideAccordion = document.querySelector(
          `.js-accordion [href="${this.getAttribute("href")}"]`
        );

        let scrollOffset = 18;
        const header = document.querySelector(".js-header");
        if (header && header.classList.contains("js-header-sticky")) {
          scrollOffset = header.offsetHeight + 18;
        }

        window.scrollTo({
          top: outsideAccordion.getBoundingClientRect().top + window.scrollY - scrollOffset,
          behavior: "smooth"
        });

        target.classList.add(activeClass);
        slideDown(target);
        outsideAccordion.classList.add(activeClass);
        return;
      }

      // toggle open / close
      if (target.classList.contains(activeClass)) {
        this.classList.remove(activeClass);
        this.setAttribute("aria-expanded", "false");
        target.classList.remove(activeClass);
        slideUp(target);
      } else {
        target.classList.add(activeClass);
        slideDown(target);
        this.classList.add(activeClass);
        this.setAttribute("aria-expanded", "true");
      }
    });
  });
};
// end custom js by gj 

window.theme.wrapRteTables();
window.theme.accordion(); //custom js by gj
window.theme.productCollSwatch(); //custom js by gj

const scrollEndSupported = typeof window === "undefined" ? true : "onscrollend" in window;

if (!scrollEndSupported) {
    import("scrollyfills");
}
//# sourceMappingURL=global.js.map


// custom js by gj
// Open size table
document.querySelectorAll(".product-size-table-link").forEach(link => {
  link.addEventListener("click", function (e) {
    e.preventDefault();

    const modal = document.getElementById("productSizeTable");
    const img = modal.querySelector("img");

    img.setAttribute("src", this.dataset.link);
    modal.style.display = "block";
  });
});

// Close size table
const closeIcon = document.querySelector("#productSizeTable i.icon--close");
if (closeIcon) {
  closeIcon.addEventListener("click", function () {
    const modal = document.getElementById("productSizeTable");
    modal.style.display = "none";
  });
}

// Color filter click
document.querySelectorAll(".gf-option-one-color").forEach(option => {
  option.addEventListener("click", function () {
    const colors = this.dataset.colors;
    if (!colors) return;

    const colorArray = colors.split(",");
    const filterContainer = document.getElementById("filter-1");
    const form = document.querySelector("form.collection-sidebar__filter-form");

    if (this.classList.contains("active")) {
      // remove checked inputs
      colorArray.forEach(color => {
        const input = document.querySelector(
          `input[name="filter.v.option.kolor"][value="${color}"]`
        );
        if (input) {
          input.removeAttribute("checked");
        }
      });
    } else {
      // add hidden checked inputs
      colorArray.forEach(color => {
        const input = document.createElement("input");
        input.type = "checkbox";
        input.name = "filter.v.option.kolor";
        input.value = color;
        input.checked = true;
        input.style.display = "none";

        filterContainer.appendChild(input);
      });
    }

    // submit form
    if (form) {
      form.classList.add("js-loading");
      form.submit();
    }
  });
});

// end custom js by gj
